<template>
    <div id="fb-sidebar-bottom" class="white-box new-contact" v-if="contacts">
        <p class="sidebar-title text-center mb-0 text-grey-666 fs-12">
            {{ $t('new-contact') }} ({{ Object.keys(contacts).length }})
        </p>
        <p class="sidebar-date">
            <small class="text-grey-9 fs-12">
                {{ $t('since-the') }} {{ fromDate }}
            </small>
        </p>
        <ul class="nav fa-ul flex-column mt-3 " v-if="contacts">
           <li class="nav-item menu-item text-left"
                v-for="contact in contacts" :key="contact.id">
                <router-link @click.native="showContact(contact.id)" :to="{ name: '' }" class="text-grey-666 fs-12">
                    <span v-if="(contact.attributes['facebook-id'] !== undefined && contact.attributes['facebook-id'] !== null)">
                        <font-awesome-icon class="fa-li mt-1 text-primary" :icon="['fab', 'facebook-f']" />
                    </span>
                    <span class="text-primary" v-else>
                        <font-awesome-icon class="fa-li mt-1 text-primary" :icon="['fas', 'mobile-alt']"/>
                    </span>
                    {{ contact.attributes['facebook-id'] !== null ? shortenedName(contact.attributes['facebook-name']) : shortenedName(contact.attributes.name) }}
                </router-link>
            </li>
        </ul>
        <div class="new-contact-list mt-3 mx-5" v-if="contacts && contacts.length > 10">
            <a href="#" v-b-modal.new-contact-modal @click.prevent><p class="pt-2">{{ $t('see-more') }}</p></a>
        </div>
        <base-modal
            id="new-contact-modal"
            size="xl"
            :title="$t('new-contact')"
            :subtitle="`${$t('7days-new-contact')} ( ${contacts != null ? contacts.length : ''} )`"
        >
            <div class="d-flex flex-wrap flex-column modal-list">
                <router-link
                    v-for="contact in contacts"
                    :key="contact.id"
                    @click.native="showContactFromModal(contact.id)"
                    :to="{ name: '' }"
                    class="contact-link d-flex">
                    <font-awesome-icon class="text-primary" :icon="['fab', 'facebook-f']" />
                    <p class="ml-3">{{ contact.attributes.name }}</p>
                </router-link>
            </div>
            <template #footer>
                <a href="/contacts"><p>{{ $t('see-all-contacts') }}</p></a>
            </template>
        </base-modal>
    </div>
</template>
<script>

// External external libraries
import moment                   from 'moment';
import { mapState, mapActions } from 'vuex';
import { EventBus }             from '@/helpers/EventBus.js';

// Internal components
import BaseModal from '@/core/components/BaseModal.vue';

// Number of days to subtract
const daysNumber = 7;

export default {
    components: { BaseModal },

    mounted () {
        this.indexNew();

        // Update the contact list after importing contacts
        EventBus.$off('contact-imported');
        EventBus.$on('contact-imported', () => {
            this.indexNew();
        });
    },

    data () {
        return {
            contactName: null,
            fromDate:    moment()
                .locale('fr-ca')
                .subtract(daysNumber, 'days')
                .format('LL')
        };
    },

    computed: {
        ...mapState('core/contacts', { 'contacts': 'newContacts' }),

        /**
         * State of facebook and sms connectors
         *
         * facebook    State of the facebook connector
         * sms         State of the sms connector
         */
        ...mapState('core/connectors', [
            'facebook'
        ])
    },

    methods: {
        ...mapActions('core/contacts', [
            'indexNew',
            'getSingle'
        ]),

        /**
         * Set the contact id to the session and redirect to single contact page
         *
         * @param   {String}    contactId   The contact id
         */
        showContact (contactId) {
            this.getSingle({ id: contactId }).then(() => {
                this.$router.push({ name: `contact:${this.$i18n.locale}` });
            });
        },

        /**
         * Close the new contacts modal and show the given contact
         *
         * @param   {String}    contactId   The contact id
         */
        showContactFromModal (contactId) {
            this.$bvModal.hide('new-contact-modal');
            this.showContact(contactId);
        },

        /**
         * Shorten the preview name of the contact
         *
         * @param     {string}    name    The contact name
         *
         * @return    {string}    The shortened name
         */
        shortenedName (contactName) {
            const nameMaxLength = 19;
            return contactName.length > nameMaxLength ? `${contactName.slice(0, nameMaxLength)}...` : contactName;
        }
    }
};
</script>
